
import { themeScheduleSummaryAdapter, ThemeScheduleSummaryState } from './theme-schedule-summary.entity';
import { EntityState } from '@ngrx/entity';
import { ScheduleSummary } from './../../../api/models/schedule-summary.model';
import { Action, on, createReducer } from '@ngrx/store';
import { themeScheduleSummaryActionTypes } from './theme-schedule-summary.actions';
import { authActionTypes } from './../../../auth/store/auth.actions';

export const initialState: ThemeScheduleSummaryState = themeScheduleSummaryAdapter.getInitialState({
    ids: [],
    loaded: false,
    total: null
});

export const themeScheduleSummaryReducerObj = createReducer(
    initialState,

    on(themeScheduleSummaryActionTypes.setThemeScheduleSummaryAction, (state, action) =>

        themeScheduleSummaryAdapter.addAll(action.themeScheduleSummaryList, {
            ...state,
            loaded: true,
            total: action.themeScheduleSummaryList.length
        })
    ),

    on(themeScheduleSummaryActionTypes.addThemeScheduleSummarySuccess, (state, action) =>

        themeScheduleSummaryAdapter.addOne(action.themeScheduleSummary, {
            ...state,
            total: state.total + 1
        })
    ),

    on(authActionTypes.LogOut, (state, action) => {
        // return accountAdapter.removeAll({ ...state, currentAccount:null })
        return themeScheduleSummaryAdapter.removeAll({
            ...state,
            loaded: false,
            total: 0
        });
    }),

    on(themeScheduleSummaryActionTypes.updateThemeScheduleSummarySuccess, (state, action) =>

        themeScheduleSummaryAdapter.updateOne(action.update, state)
    ),

    on(themeScheduleSummaryActionTypes.deleteThemeScheduleSummarySuccess, (state, action) =>

        themeScheduleSummaryAdapter.removeOne(action.themeId, state)
    ),
);

export function reducer(state: ThemeScheduleSummaryState = initialState, action: Action):ThemeScheduleSummaryState {
    return themeScheduleSummaryReducerObj(state, action);
}

export const themeScheduleSummarySelectors = themeScheduleSummaryAdapter.getSelectors();